module.exports = __webpack_public_path__ + "static/media/battery-banesco-selected.a1e6f067.svg";